module.exports = __webpack_public_path__ + "static/media/logo.0ce61567.png";